import React from "react";
import { Search, X } from "lucide-react";
import { Autocomplete, TextField } from "@mui/material";



function FitrosLocales({
    buscar,
    handleBuscar,
    empresaSelected,
    handleEmpresaSelected,
    fechaDesde,
    handleFechaDesde,
    fechaHasta,
    handleFechaHasta,
    dataLocales
}) {





    return (
        <div className="rounded-xl bg-white p-4 shadow-sm border border-gray-200 mb-6">
            <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">

                {/* Buscar local */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Buscar
                    </label>
                    <div className="relative flex items-center">
                        <Search size={16} className="absolute left-3 text-gray-400 pointer-events-none" />
                        <input
                            type="text"
                            value={buscar}
                            onChange={(e) => handleBuscar(e.target.value)}
                            autoCapitalize="none"
                            autoCorrect="off"
                            placeholder="Buscar por razón social, RUC o nombre de fantasía"
                            className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] py-2 pl-9 pr-9 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                        />
                        {buscar && (
                            <button
                                type="button"
                                onClick={() => handleBuscar("")}
                                className="absolute right-3 text-gray-400 hover:text-gray-600 transition-colors"
                            >
                                <X size={15} />
                            </button>
                        )}
                    </div>
                </div>


                {/* Locales */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">Locales</label>
                    <Autocomplete
                        disablePortal
                        options={dataLocales}
                        fullWidth
                        value={empresaSelected || null}
                        getOptionLabel={(option) => {
                            if (!option) return "";
                            if (typeof option === "string") return option;
                            const nombreFantasia = option?.nombre_fantasia || "";
                            const ruc = option?.ruc ? `RUC: ${option.ruc}` : "";
                            const razonSocial = option?.razon_social || "";
                            return [nombreFantasia, ruc, razonSocial].filter(Boolean).join(" - ");
                        }}
                        renderOption={(props, option) => (
                            <li {...props} key={option?.id}>
                                <div className="flex flex-col">
                                    <span className="text-sm text-gray-800 font-medium">
                                        {option.nombre_fantasia || option.razon_social || "Sin nombre"}
                                    </span>
                                    <span className="text-xs text-gray-500">
                                        RUC: {option.ruc || "-"}
                                    </span>
                                </div>
                            </li>
                        )}
                        isOptionEqualToValue={(option, value) => option?.id === value?.id}
                        onChange={(event, value) => {
                            // Al seleccionar una empresa se usa su id para el parametro empresa_id.
                            handleEmpresaSelected(value);
                        }}
                        loadingText={"Cargando..."}
                        noOptionsText={"No hay opciones"}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Seleccione una empresa"
                                size="small"
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        backgroundColor: '#f1f5f9',
                                        borderRadius: '0.5rem',
                                        fontSize: '0.875rem',
                                    },
                                }}
                            />
                        )}
                    />
                </div>

                {/* Fecha desde */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Fecha desde
                    </label>
                    <input
                        type="date"
                        value={fechaDesde}
                        onChange={(e) => handleFechaDesde(e.target.value)}
                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                    />
                </div>

                {/* Fecha hasta */}
                <div>
                    <label className="mb-1.5 block text-sm font-semibold text-gray-700">
                        Fecha hasta
                    </label>
                    <input
                        type="date"
                        value={fechaHasta}
                        onChange={(e) => handleFechaHasta(e.target.value)}
                        className="w-full rounded-lg border border-gray-200 bg-[#f1f5f9] px-3 py-2 text-sm text-gray-700 outline-none transition focus:border-blue-200 focus:ring-2 focus:ring-blue-200"
                    />
                </div>

            </div>
        </div>
    );
}

export default FitrosLocales;